import {
    connect,
    IClientOptions,
    IDisconnectPacket,
    MqttClient,
    OnDisconnectCallback,
    OnMessageCallback
} from "precompiled-mqtt";
import {Handler} from "mitt";
import emit from "@/lib/emit";

interface IPkt {
    action: string
    res: unknown
}

interface IAccount {
    user: string
    password: string
}

export class Broker {
    private conn: MqttClient
    private pkts: IPkt[] = []
    private subs: string[] = ['service.recharge','service.used','wallet']

    constructor() {
        this.conn = this.connect();
    }

    private connect(): MqttClient {
        const a = this.account()
        console.log("connecting", a);
        const conn = connect('wss://broker.mqtt.guandb.cn/mqtt', {
            clientId: `activity/pc/${a.user}/${Math.random().toString(36).substring(2, 5)}`,
            username: a.user,
            password: a.password,
            will: {
                topic: `h5/pc/activity/${a.user}/disconnect`,
                payload: new TextEncoder().encode(JSON.stringify({})),
                qos: 0,
                retain: false
            },
            protocolVersion: 5,
            keepalive: 29,
            clean: false,
        } as IClientOptions)
        conn.on("connect", this.onConnect)
        conn.on("error", this.onError)
        conn.on('message', this.onMessage as OnMessageCallback)
        conn.on('disconnect', this.onDisconnect as OnDisconnectCallback)
        conn.on('reconnect', this.onReconnect)
        return conn
    }

    private onConnect = (): void => {
        console.log("connected")
        this.pkts.forEach(p => this.publish(p.action, p.res))
        this.pkts = []
        this.subs.forEach(sub => {
            this.conn.subscribe(this.subTopic(sub))
        })
        // this.subs = []
    }

    private onReconnect = (): void => {
        console.log("reconnect")
    }

    private onError = (err: Error): void => {
        this.conn.end(true)
        if (err.message.includes('Not authorized')) emit.emit('session.timeout')
        console.log('broker onError:', err.message, err.message.includes('Not authorized'));
    }

    private onMessage = (topic: string, payload: Buffer): void => {
        console.log("Received message", topic);
        try {
            emit.emit(this.subTopicDecode(topic), JSON.parse(payload.toString()))
        } catch (e) {
            console.warn((e as Error).message)
        }
    }

    private onDisconnect = (packet: IDisconnectPacket): void => {
        console.log("Received disconnect packet", packet.reasonCode, packet)
    }

    private account(): IAccount {
        const arr = document.cookie.split('; ').map(i => i.split('='))
        for (const v of arr) {
            if (v.length == 2 && v[0] == 'token') return {
                user: v[1].substring(0, 22),
                password: decodeURIComponent(v[1].substring(22))
            }
        }
        return {user: '', password: ''}
    }

    publish(action: string, res: unknown): void {
        if (!this.conn.connected) this.pkts.push({action, res})
        else {
            this.conn.publish(this.pubTopic(action), JSON.stringify(res), {
                qos: 1,
                retain: false
            }, (err) => {
                if (err) {
                    console.error(err)
                    this.pkts.push({action, res})
                }
            })
            // console.log(`h5/mp/${browserId}/${auth?.user}/${action}`, JSON.stringify(res))
        }
    }

    subscribe(action: string, handler: Handler) {
        this.conn.subscribe(this.subTopic(action), (err) => {
            if (err) console.error(err)
            else {
                this.subs.push(action)
                emit.on(action, handler)
            }
        })
    }

    unsubscribe(action: string) {
        this.conn.unsubscribe(this.subTopic(action), {}, (err) => {
            if (err) console.error(err)
            else {
                this.subs = this.subs.filter(i => i !== action)
                emit.off(action)
            }
        })
    }

    private subTopicDecode = (topic: string): string => topic.replace(`event/mp/activity/${this.account().user}/`, '')
    private subTopic = (action: string): string => `event/mp/activity/${this.account().user}/${action}`
    private pubTopic = (action: string): string => `h5/pc/activity/${this.account().user}/${action}`
}